import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './lineChart1.module.css';
import * as echarts from 'echarts';
import {getHzForTermListXueqiRequest} from "../../../service/report";
import PubSub from "pubsub-js";
var myLineChart = null;

class LineChart1 extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'initLineBar'
        ]);

        this.state = {

        };

    }

    componentDidMount() {
        getHzForTermListXueqiRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)
            PubSub.publish('lineChart111Update',data);
            if (data.ret == '1') {
                this.setState({

                });

                var list = data.data[0];
                var list1 = [];
                var list2 = [];

                for (var i = 0; i < list.length; i++) {
                    list1.push(list[i].weekdata_hz)
                    list2.push(list[i].class_avg_hz)
                }

                this.initLineBar(list1,list2);

            }
        });

    }

    componentDidUpdate() { // 组件更新后触发


    }

    componentWillUnmount (){
        myLineChart.dispose();
    }

    initLineBar(data1,data2) {
        const option = {
            legend: { //图例
                data: ['我的徽章', '班级平均'],
                right: '3%',
                top: '2%',
                icon:'roundRect',
                itemGap: 20,//图例每项之间的间隔 number
                itemWidth: 15,//图例标记的图形宽度
                itemHeight: 14,
                itemStyle: {
                    // borderWidth: 0,
                    borderColor: ['#4a8fdd', '#75c321'],//图例圆圈颜色
                },
                textStyle: {
                    fontSize: 16,//字体大小
                    color: ['#4a8fdd', '#75c321']//字体颜色
                },
            },
            tooltip: {//提示框组件
                trigger: 'axis',//触发类型 item(散点图，饼图) axis(柱状图，折线图等)
                axisPointer: {
                    type: 'cross',//指示类型
                    label: {
                        // 横纵坐标指示区块颜色
                        backgroundColor: '#6a7985'
                    },

                },
                textStyle: {
                    //fontSize: 16,//字体大小

                },
            },
            grid: {//图标距离容器的边距
                left: '9%',
                top: '30%',
                right: '10%',
                bottom: '15%',
                // containLabel: true
            },
            xAxis: [{//直角坐标系 grid 中的 x 轴
                name: '月',
                nameTextStyle:{
                    fontSize: 14,
                },
                axisLabel: {//坐标轴刻度标签
                    margin: 15,//刻度标签与轴线之间的距离
                    // color: '#000000',
                    textStyle: {
                        fontSize: 14,
                        color: '#7fc5ff'//字体颜色
                    },
                },
                axisLine: {
                    lineStyle: {//x轴
                        color: '#7fc5ff',
                        width: 2, //这里是为了突出显示加上的
                    },
                    symbol: [ 'none','arrow'], // 轴线两端箭头，两个值，none表示没有箭头，arrow表示有箭头
                    symbolSize: [6, 6],
                },
                splitLine: {     //网格线
                    "show": false
                },
                axisTick:{show:false},
                //boundaryGap: false,//坐标轴两边留白策略
                data: ['第一个月','第二个月','第三个月','第四个月'],
            }],
            yAxis: [{
                name: '徽章数',
                nameTextStyle:{
                    fontSize: 14,
                },
                splitLine: {//坐标轴在 grid 区域中的分隔线
                    show:false,
                    lineStyle: {
                        color: '#7fc5ff',
                        width: 1,
                    }
                },
                axisLabel: {
                    show:false,
                    margin: 10,
                    textStyle: {
                        color: '#000000',
                        fontSize: 14,
                    },
                },

                axisLine: {
                    lineStyle: {//x轴
                        color: '#7fc5ff',
                        width: 2, //
                    },
                    show: true, //是否显示坐标轴轴线
                    symbol: [ 'none','arrow'], // 轴线两端箭头，两个值，none表示没有箭头，arrow表示有箭头
                    symbolSize: [6, 6],
                },
            }],

            series: [
                {
                    name: '我的徽章',
                    type: 'line',
                    // smooth: true, //是否平滑
                    showAllSymbol: true,
                    symbol: 'circle',
                    color:'#4a8fdd',
                    symbolSize: 12,
                    lineStyle: {
                        width: 2,
                        color:'#4a8fdd'
                    },
                    label: {
                        show: true,
                        textStyle: {
                            color: '#4a8fdd',
                            fontSize: 14,
                        }
                    },
                    data: data1,
                },
                {
                    name: '班级平均',
                    type: 'line',
                    showAllSymbol: true,
                    symbol: 'circle',
                    color:'#75c321',
                    symbolSize: 12,
                    lineStyle: {
                        width: 2,
                        color:'#75c321'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#75c321',
                            fontSize: 14,
                        }
                    },

                    data: data2,
                },
            ],
        };
        myLineChart = echarts.init(document.getElementById('lineChart111'));
        myLineChart.setOption(option, true)

    }


    render() {

        return (
            <div className={styles.root}>

                <div id="lineChart111" className={styles.echart} ></div>

            </div>
        )
    }
}


export default LineChart1;
